/**
 * maath の easing.dampAngle / damp 相当の最小移植（本のめくりイージング用）。
 * smoothTime は「目標へ収束するおおよその時間（秒）」。小さいほど速い。
 */

// 角度を [-π, π) に正規化する
export function wrapAngle(angle) {
  const TAU = Math.PI * 2
  return ((angle + Math.PI) % TAU + TAU) % TAU - Math.PI
}

// 指数減衰で current を target に近づける（非角度値用）
export function damp(current, target, smoothTime, dtSeconds) {
  return current + (target - current) * (1 - Math.exp(-(5 / smoothTime) * dtSeconds))
}

// 角度版: 最短経路（±πをまたぐ側）で target に近づける
export function dampAngle(current, target, smoothTime, dtSeconds) {
  return current + wrapAngle(target - current) * (1 - Math.exp(-(5 / smoothTime) * dtSeconds))
}

// 緩やかに始まり・緩やかに終わるイージング（めくりの進行度用）
export function easeInOutCubic(t) {
  return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2
}
